import type { FC, ReactNode } from 'react';

import CopyrightFooter from 'src/app/components/Elements/CopyrightFooter';
import { HeartAnimation } from 'src/app/components/Elements/HeartAnimation';
import type { ThemeSpaceType } from 'src/styles/theme';

import { ContentContainer, CopyLine, FooterRow, LastLine, OuterContainer, Title } from './styles';

interface PageTitleBodyAndFooterProps {
  secondaryMarginBottom?: ThemeSpaceType;
  secondaryText?: ReactNode;
  showInterstitial: boolean;
  tertiaryText?: ReactNode;
  title: ReactNode;
}

export const PageTitleBodyAndFooter: FC<PageTitleBodyAndFooterProps> = ({
  children,
  secondaryMarginBottom,
  secondaryText,
  showInterstitial,
  tertiaryText,
  title,
}) => {
  if (showInterstitial) return <HeartAnimation />;

  return (
    <OuterContainer>
      <ContentContainer>
        <Title>{title}</Title>
        {secondaryText && <CopyLine marginBottom={secondaryMarginBottom}>{secondaryText}</CopyLine>}
        {tertiaryText && <LastLine>{tertiaryText}</LastLine>}
        {children}
      </ContentContainer>
      <FooterRow>
        <CopyrightFooter isAlignedRight textColor={'gray'} />
      </FooterRow>
    </OuterContainer>
  );
};
